import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const AirTrackingIntegration = () => {
  return (
    <>
      <div className={styles.wrapperInputs}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many AWBs (air waybills) do you need to track per month?"
          fieldName={INPUT_FIELD_NAMES.airTrackingmonthly_shipments}
          className={styles.perDay}
        />
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many searches on your website do you expect per month (all users)?"
          fieldName={INPUT_FIELD_NAMES.airTrackingSearchesPerMonth}
          className={styles.inputSearches}
        />
      </div>
      <div className={styles.wrapperSelects}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many licenses (domains) do you need?"
          fieldName={INPUT_FIELD_NAMES.airTrackingLicences}
          className={styles.licence}
        />
      </div>
    </>
  );
};
